"use strict";

exports.__esModule = true;
exports["default"] = CircleCheck;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CircleCheck(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.002.069C7.197.069.063 7.202.063 16.009c0 8.789 7.134 15.922 15.939 15.922 8.792 0 15.936-7.133 15.936-15.922 0-8.807-7.144-15.94-15.936-15.94zm8.165 11.769L16.031 23.62a2.637 2.637 0 0 1-3.791.033l-5.118-5.43a2.614 2.614 0 0 1-.769-1.865 2.642 2.642 0 0 1 .774-1.885 2.665 2.665 0 0 1 1.89-.767c.716 0 1.403.278 1.885.76l2.708 2.964 6.753-9.312a2.627 2.627 0 0 1 1.901-.787c.712 0 1.399.274 1.885.747a2.674 2.674 0 0 1 .018 3.76z"
  }));
}